import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Footer = ({ setCurrentPage }) => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLinkClick = (page) => {
    console.log('Footer link clicked:', page); // Debug log
    
    // Check if this is a public route
    const publicRoutes = {
      'terms': '/terms-of-service',
      'privacy': '/privacy-policy', 
      'guidelines': '/community-guidelines',
      'support': '/support',
      'contact': '/contact-us'
    };

    if (publicRoutes[page]) {
      navigate(publicRoutes[page]);
    } else {
      // For internal authenticated app pages
      if (setCurrentPage) {
        setCurrentPage(page);
      }
    }
  };

  const footerLinks = {
    'Company': [
      { name: 'About Us', page: 'about' },
      { name: 'Contact Us', page: 'contact' },
      { name: 'Blog', page: 'blog' }
    ],
    'Legal': [
      { name: 'Terms of Service', page: 'terms' },
      { name: 'Privacy Policy', page: 'privacy' },
      { name: 'Community Guidelines', page: 'guidelines' }
    ],
    'Support': [
      { name: 'Help Center', page: 'contact' },
      { name: 'Community', page: 'social' },
      { name: 'Membership', page: 'membership' },
      { name: '👉 Support', page: 'support' }
    ]
  };

  return (
    <footer style={{
      background: 'linear-gradient(135deg, var(--text-dark), var(--soft-ash))',
      color: 'white',
      padding: '3rem 2rem 1rem',
      marginTop: '4rem'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        
        {/* Main Footer Content */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
          gap: '2rem',
          marginBottom: '2rem'
        }}>
          
          {/* Brand Section */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
              <img 
                src="/logo.webp" 
                alt="Zero Give Up" 
                style={{ height: '40px', marginRight: '1rem' }}
              />
              <h3 style={{ color: 'white', margin: 0 }}>ZeroGiveUp</h3>
            </div>
            <p style={{ color: 'rgba(255,255,255,0.8)', lineHeight: '1.6', marginBottom: '1.5rem' }}>
              Empowering individuals to achieve their goals through community support, 
              accountability, and unwavering determination. No excuses, just progress.
            </p>
            
            {/* Social Links */}
            <div style={{ display: 'flex', gap: '1rem' }}>
              <a href="#" style={{ 
                color: 'rgba(255,255,255,0.8)', 
                fontSize: '1.5rem',
                transition: 'color 0.3s ease' 
              }}>📧</a>
              <a href="#" style={{ 
                color: 'rgba(255,255,255,0.8)', 
                fontSize: '1.5rem',
                transition: 'color 0.3s ease' 
              }}>🐦</a>
              <a href="#" style={{ 
                color: 'rgba(255,255,255,0.8)', 
                fontSize: '1.5rem',
                transition: 'color 0.3s ease' 
              }}>📘</a>
              <a href="#" style={{ 
                color: 'rgba(255,255,255,0.8)', 
                fontSize: '1.5rem',
                transition: 'color 0.3s ease' 
              }}>📸</a>
            </div>
          </div>

          {/* Link Sections */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 style={{ 
                color: 'white', 
                marginBottom: '1rem',
                fontSize: '1.1rem',
                fontWeight: '600'
              }}>
                {category}
              </h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {links.map((link) => (
                  <li key={link.name} style={{ marginBottom: '0.5rem' }}>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleLinkClick(link.page);
                      }}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: 'rgba(255,255,255,0.8)',
                        cursor: 'pointer',
                        fontSize: '0.95rem',
                        textAlign: 'left',
                        padding: '0.25rem 0',
                        transition: 'color 0.3s ease',
                        width: '100%'
                      }}
                      onMouseOver={(e) => e.target.style.color = 'var(--primary-fire)'}
                      onMouseOut={(e) => e.target.style.color = 'rgba(255,255,255,0.8)'}
                    >
                      {link.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Newsletter/CTA Section */}
          <div>
            <h4 style={{ 
              color: 'white', 
              marginBottom: '1rem',
              fontSize: '1.1rem',
              fontWeight: '600'
            }}>
              Stay Motivated
            </h4>
            <p style={{ color: 'rgba(255,255,255,0.8)', marginBottom: '1rem', fontSize: '0.9rem' }}>
              Join members committed to building stability, clarity, and steady growth.
            </p>
            <button 
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleLinkClick('membership');
              }}
              style={{
                background: 'linear-gradient(135deg, var(--primary-fire), var(--secondary-flame))',
                color: 'white',
                border: 'none',
                padding: '0.75rem 1.5rem',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: '600',
                fontSize: '0.9rem',
                transition: 'transform 0.2s ease'
              }}
              onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
              onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
            >
              Start Your Journey
            </button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.2)',
          paddingTop: '1.5rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1rem'
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%' }}>
            <p style={{ 
              color: 'rgba(255,255,255,0.6)', 
              margin: 0,
              fontSize: '0.9rem',
              textAlign: 'center'
            }}>
              © 2025 ZeroGiveUp.com — All Rights Reserved
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem', flexWrap: 'wrap' }}>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleLinkClick('terms');
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'rgba(255,255,255,0.6)',
                  cursor: 'pointer',
                  fontSize: '0.85rem',
                  transition: 'color 0.3s ease'
                }}
                onMouseOver={(e) => e.target.style.color = 'white'}
                onMouseOut={(e) => e.target.style.color = 'rgba(255,255,255,0.6)'}
              >
                Terms of Service
              </button>
              <span style={{ color: 'rgba(255,255,255,0.6)' }}>|</span>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleLinkClick('privacy');
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'rgba(255,255,255,0.6)',
                  cursor: 'pointer',
                  fontSize: '0.85rem',
                  transition: 'color 0.3s ease'
                }}
                onMouseOver={(e) => e.target.style.color = 'white'}
                onMouseOut={(e) => e.target.style.color = 'rgba(255,255,255,0.6)'}
              >
                Privacy Policy
              </button>
              <span style={{ color: 'rgba(255,255,255,0.6)' }}>|</span>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleLinkClick('support');
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'rgba(255,255,255,0.6)',
                  cursor: 'pointer',
                  fontSize: '0.85rem',
                  transition: 'color 0.3s ease'
                }}
                onMouseOver={(e) => e.target.style.color = 'white'}
                onMouseOut={(e) => e.target.style.color = 'rgba(255,255,255,0.6)'}
              >
                Support
              </button>
            </div>
          </div>
        </div>

        {/* Motivational Quote */}
        <div style={{
          textAlign: 'center',
          marginTop: '1.5rem',
          padding: '1rem',
          background: 'rgba(255,255,255,0.1)',
          borderRadius: '8px'
        }}>
          <p style={{ 
            color: 'var(--primary-fire)', 
            fontStyle: 'italic',
            margin: 0,
            fontSize: '1rem',
            fontWeight: '500'
          }}>
            "Success is not final, failure is not fatal: it is the courage to continue that counts." 💪
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;